import { BASE_URL } from "./constant";

const API_BASE = (process.env.REACT_APP_API_BASE || BASE_URL || "").replace(/\/+$/, "");

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function request(path, options = {}) {
  const response = await fetch(buildUrl(path, options.params), {
    method: options.method || "GET",
    headers: options.body ? { "Content-Type": "application/json" } : undefined,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || "Erreur Direct utilisateur");
  }

  return payload.data ?? payload;
}

export function listUserLiveRooms(params = {}) {
  return request("/api/user-live/rooms", { params });
}

export function createUserLiveRoom(payload) {
  return request("/api/user-live/rooms", {
    method: "POST",
    body: payload,
  });
}

export function getUserLiveRoom(roomId) {
  return request(`/api/user-live/rooms/${roomId}`);
}

export function startUserLiveRoom(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/start`, {
    method: "POST",
    body: payload,
  });
}

export function endUserLiveRoom(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/end`, {
    method: "POST",
    body: payload,
  });
}

export function joinUserLiveRoom(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/join`, {
    method: "POST",
    body: payload,
  });
}

export function heartbeatUserLiveRoom(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/heartbeat`, {
    method: "POST",
    body: payload,
  });
}

export function leaveUserLiveRoom(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/leave`, {
    method: "POST",
    body: payload,
  });
}

export function listUserLiveMessages(roomId, params = {}) {
  return request(`/api/user-live/rooms/${roomId}/messages`, { params });
}

export function sendUserLiveMessage(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/messages`, {
    method: "POST",
    body: payload,
  });
}

export function listUserLiveSignals(roomId, params = {}) {
  return request(`/api/user-live/rooms/${roomId}/signals`, { params });
}

export function sendUserLiveSignal(roomId, payload) {
  return request(`/api/user-live/rooms/${roomId}/signals`, {
    method: "POST",
    body: payload,
  });
}
